<template>
  <loading v-if="isPageLoading" />
  <not-auth
    v-else-if="
      getActiveUser.userInfo.departmentUserRole !== 'Admin' &&
      item.id !== getActiveUser.userInfo.id &&
      getActiveUser.userInfo.role !== 'Admin'
    "
  ></not-auth>
  <not-auth
    v-else-if="getActiveUser.userInfo.role !== 'Admin' && item.role === 'Admin'"
  ></not-auth>
  <div v-else>
    <Alert :value="{ status: true, variant: 'primary' }">
      <div>
        <i class="icofont-info-circle u-margin-right-xsmall"></i>
        <strong>{{ $t("admins.adminHint") }}</strong>
      </div>
    </Alert>
    <BaseInput
      :label="$t('admins.name')"
      :placeholder="$t('admins.namePlaceholder')"
      block
      type="text"
      :mandotary="validActivated"
      icon="user"
      v-model="form.fullname"
    />
    <BaseInput
      :label="$t('admins.email')"
      :placeholder="$t('admins.emailPlaceholder')"
      block
      type="text"
      :mandotary="validActivated"
      icon="email"
      v-model="form.email"
    />
    <PhoneInput
      :label="$t('admins.phone')"
      :placeholder="$t('admins.phonePlaceholder')"
      block
      type="number"
      :mandotary="validActivated"
      icon="phone"
      v-model="form.phoneNo"
    />
    <div class="u-margin-top" v-if="edit">
      <Checkbox
        :value="showPassword"
        @change="showPassword = !showPassword"
        :label="$t('admins.showPassword')"
      ></Checkbox>
    </div>
    <BaseInput
      v-if="showPassword"
      :label="$t('admins.password')"
      :placeholder="$t('admins.passwordPlaceholder')"
      block
      type="password"
      :mandotary="validActivated"
      icon="ui-lock"
      v-model="form.password"
    />
    <div class="c-form-control c-form-control__variant--sm">
      <div class="u-margin-bottom-xsmall">
        <label for=""> {{ $t("admins.role") }} </label>
      </div>
      <v-select
        :disabled="getActiveUser.userInfo.role !== 'Admin'"
        :class="{ 'vs-invalid': validActivated && !form.role }"
        :options="roles"
        :placeholder="$t('admins.rolePlaceholder')"
        v-model="form.role"
        :searchable="false"
        :clearable="false"
        label="name"
      >
        <template #no-options="{}">
          {{ $t("noFoundData") }}
        </template></v-select
      >
    </div>
    <DepartmentSearch
      v-model="department"
      :disabled="getActiveUser.userInfo.role !== 'Admin'"
      :label="$t('departments.title')"
    />
    <div class="c-form-control c-form-control__variant--sm" v-if="department">
      <div class="u-margin-bottom-xsmall">
        <label for="">
          {{ department.title }} {{ $t("admins.departmentRole") }}
        </label>
      </div>
      <v-select
        :disabled="
          getActiveUser.userInfo.departmentUserRole !== 'Admin' &&
          getActiveUser.userInfo.role !== 'Admin'
        "
        :class="{ 'vs-invalid': validActivated && !departmentRole }"
        :options="roles"
        :placeholder="$t('admins.rolePlaceholder')"
        v-model="departmentRole"
        :searchable="false"
        :clearable="false"
        label="name"
      >
        <template #no-options="{}">
          {{ $t("noFoundData") }}
        </template></v-select
      >
    </div>
    <div class="row u-margin-top">
      <div class="es-xs-12">
        <Button v-if="edit" block variant="warning" @click="UPDATE_IT">
          <i class="icofont-edit"></i> {{ $t("common.update") }}
        </Button>
        <Button v-else block variant="light-primary" @click="ADD_IT">
          + {{ $t("common.add") }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Alert from "@/components/Base/Alert.vue";
import Button from "@/components/Base/Button.vue";
import { Currency } from "gurhan/helpers/Currency";
import Requests from "@/services/Requests";
import { AdminRole } from "@/enums/AdminRoles";
import Checkbox from "@/components/Base/Inputs/Checkbox.vue";
import PhoneInput from "../Base/Inputs/PhoneInput.vue";
import DepartmentSearch from "@/components/Searches/DepartmentSearch.vue";
import { mapGetters } from "vuex";
import NotAuth from "../Base/NotAuth.vue";
export default {
  components: {
    Checkbox,
    Button,
    Alert,
    BaseInput,
    PhoneInput,
    DepartmentSearch,
    NotAuth,
  },
  data() {
    return {
      validActivated: false,
      showPassword: true,
      isPageLoading: true,
      form: {
        fullname: "",
        email: "",
        phoneNo: "",
        password: "",
        role: {},
      },
      department: null,
      departmentRole: null,
      roles: [
        { name: this.$t("admins.ADMIN"), value: AdminRole.ADMIN },
        { name: this.$t("admins.USER"), value: AdminRole.USER },
      ],
    };
  },
  props: {
    edit: {
      default: false,
      type: Boolean,
    },
    item: {
      default: () => ({}),
    },
    departmentId: {
      default: null,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      getActiveUser: "getActiveUser",
    }),
  },
  methods: {
    Currency,
    VALIDATION(form) {
      this.validActivated = true;
      if (!form.fullname)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("admins.name"),
          })
        );
      else if (!form.email)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("admins.email"),
          })
        );
      else if (!form.phoneNo)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("admins.phone"),
          })
        );
      else if (form.password?.length < 3 && !this.edit)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("admins.password"),
          })
        );
      else if (form.role === null)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("admins.role"),
          })
        );
      else if (this.department === null)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("departments.title"),
          })
        );
      else if (this.departmentRole === null)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("admins.departmentRole"),
          })
        );
      return "OK";
    },
    /**
     * Clears form fields before making a request based on the selected rule type.
     *
     * @param {Object} form - The form object to be cleared.
     * @return {Object} The cleared form object.
     */
    CLEAR_FORM_BEFORE_REQUEST(form) {
      return form;
    },
    VALIDATION_ERROR_MESSAGE(message) {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: false,
        status: true,
        message: message,
        variant: "danger",
        duration: 2500,
      });
      return "FAIL";
    },
    async UPDATE_IT(e, loading) {
      loading(true);
      let form = {
        fullname: this.form.fullname,
        email: this.form.email,
        phoneNo: this.form.phoneNo,
        password: this.form.password,
        role: this.form.role.value,
      };

      // validation
      const valid = this.VALIDATION(form);
      if (valid !== "OK") return loading(false);
      // clear form before request
      form = this.CLEAR_FORM_BEFORE_REQUEST(form);

      const response = await Requests.Admin.Update(form, {
        params: { id: this.item.id },
      });
      if (response.message === "OK") {
        await this.UPDATE_DEPARTMENT_USER();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("admins.updateSuccess"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async ADD_IT(e, loading) {
      loading(true);
      let form = {
        fullname: this.form.fullname,
        email: this.form.email,
        phoneNo: this.form.phoneNo,
        password: this.form.password,
        role: this.form.role.value,
      };

      // validation
      const valid = this.VALIDATION(form);
      if (valid !== "OK") return loading(false);
      // clear form before request
      form = this.CLEAR_FORM_BEFORE_REQUEST(form);

      const response = await Requests.Admin.Create(form);
      if (response.message === "OK") {
        await this.ADD_DEPARTMENT_USER(response.data);
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("admins.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async ADD_DEPARTMENT_USER(id) {
      if (
        this.getActiveUser.userInfo.role === "Admin" ||
        this.getActiveUser.userInfo.departmentUserRole === "Admin"
      ) {
        const response = await Requests.DepartmentUser.Create({
          departmentId: this.department.id,
          userId: id || this.item.id,
          departmentUserRole: this.departmentRole.value,
        });
        if (response.message === "OK") {
          this.$emit("redirect:to", response.data);
        }
        return response.message;
      }
      return "NOT_AUTHORIZED";
    },
    async UPDATE_DEPARTMENT_USER() {
      if (
        this.getActiveUser.userInfo.role === "Admin" ||
        this.getActiveUser.userInfo.departmentUserRole === "Admin"
      ) {
        if (!this.item.departmentUserId)
          return await this.ADD_DEPARTMENT_USER();
        const response = await Requests.DepartmentUser.Update(
          {
            departmentId: this.department.id,
            userId: this.item.id,
            departmentUserRole: this.departmentRole.value,
          },
          {
            params: { id: this.item.departmentUserId },
          }
        );
        if (response.message === "OK") {
          this.$emit("refresh");
        }
        return response.message;
      }
      return "NOT_AUTHORIZED";
    },
    async CHECK_EDIT() {
      this.isPageLoading = true;
      if (this.edit) {
        this.showPassword = false;

        this.form = {
          fullname: this.item.fullname,
          email: this.item.email,
          phoneNo: this.item.phoneNo,
          password: this.item.password,
          role: this.roles.find((role) => role.value === this.item.role),
        };
        await this.GET_DEPARTMENT_BY_ID(this.item.departmentId);
      } else {
        this.form.role = this.roles[0];
        if (this.departmentId) {
          await this.GET_DEPARTMENT_BY_ID(this.departmentId);
        }
      }
      if (this.getActiveUser.userInfo.role !== "Admin") {
        this.form.role = this.roles[1];
      }
      setTimeout(() => {
        this.isPageLoading = false;
      }, 250);
    },
    async GET_DEPARTMENT_BY_ID(departmentId) {
      if (!departmentId) return;
      const response = await Requests.Department.GetById({
        params: { id: departmentId },
      });
      if (response.message === "OK") {
        this.department = response.data;
        this.departmentRole = this.roles.find(
          (role) => role.value === this.item.departmentUserRole
        );
      }
      return response;
    },
  },
  created() {
    this.CHECK_EDIT();
  },
};
</script>

<style></style>
